import { writable } from 'utils/state'
import { Component } from 'utils/jsx'
import cuid from 'cuid'

export default class StepSelect extends Component {
  beforeRender (props) {
    this.update = this.update.bind(this)
    this.handleChange = this.handleChange.bind(this)

    this.state = {
      id: props.id || cuid(),
      value: props['store-value'] || writable(props.value || 0),
      options: props['store-options'] || writable(props.options || [])
    }
  }

  template (props) {
    return (
      <div class='select' id={this.state.id} data-label={props.label}>
        <label class='select__dropdown' for={this.state.id}>
          <i class='fa fa-chevron-down' />
        </label>
        <select
          ref={this.ref('select')}
          event-change={this.handleChange}
        />
      </div>
    )
  }

  afterRender () {
    this.state.options.subscribe(this.update)
    this.update()
  }

  handleChange (e) {
    const value = e.target.value
    this.state.options.update(options => {
      for (const option of options) {
        option.selected = option.value === value
      }
    }, true)

    this.state.value.set(isNaN(value) ? value : +value)
  }

  update () {
    this.refs.select.innerHTML = ''
    for (const option of this.state.options.get()) {
      this.render((
        <option
          value={option.value}
          disabled={option.disabled}
          selected={option.selected}
        >
          {option.label || option.value}
        </option>
      ), this.refs.select)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Select.js